module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu __limited-edu--uob __uob-2024"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg"
  }, [_vm._v("\n                  ไม่ต้องการรับของที่ระลึก\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.rewardTitleText) + " "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "value": _vm.tshirtProductName,
      "checked": _vm._q(_vm.attributes.info.rewardProduct, _vm.tshirtProductName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", _vm.tshirtProductName)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTakeReward),
      expression: "isTakeReward"
    }],
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--lmt-deu"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "current-thumbnail-wrapper",
    on: {
      "click": function($event) {
        return _vm.showImage(_vm.currentThumbnailImage)
      }
    }
  }, [_c('img', {
    staticClass: "ma-auto d-block pd-15",
    attrs: {
      "src": _vm.currentThumbnailImage,
      "alt": "Limited Education"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mb-10 d-flex justify-content-center",
    staticStyle: {
      "margin-top": "-2rem"
    }
  }, _vm._l((_vm.thumbnailImages), function(thumbnail, i) {
    return _c('div', {
      key: i,
      staticClass: "col-sm-4 col-md-3"
    }, [_c('div', {
      staticClass: "thumbnail-wrapper",
      class: {
        selected: thumbnail === _vm.currentThumbnailImage
      },
      on: {
        "click": function($event) {
          return _vm.changeThumbnail(thumbnail)
        }
      }
    }, [_c('img', {
      staticClass: "ma-auto d-block",
      attrs: {
        "src": thumbnail,
        "alt": "Limited Education"
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("* ลวดลายของสินค้าอาจมีการเปลี่ยนแปลง / the design of merchandise is for reference only.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-10"
  }, [_c('strong', [_vm._v("เลือกขนาดเสื้อและจำนวน")]), _vm._v(" "), _c('strong', {
    staticClass: "choice-selected"
  }, [_vm._v(_vm._s(_vm.selectedSizeCount) + "/" + _vm._s(_vm.rewardCount))])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-size-choice"
  }, [_vm._l((_vm.sizeOptions), function(sizeOption) {
    return _c('div', {
      key: sizeOption.text,
      staticClass: "size-choice",
      class: {
        active: _vm.hasSelectedSize(sizeOption.text),
        'only-one': _vm.rewardCount === 1
      },
      on: {
        "click": function($event) {
          return _vm.selectSize(sizeOption.text)
        }
      }
    }, [_c('label', {}, [_vm._v(_vm._s(sizeOption.text))]), _vm._v(" "), _c('div', {
      staticClass: "text-remark"
    }, [_vm._v(_vm._s(sizeOption.description))]), _vm._v(" "), _c('div', {
      staticClass: "number-field"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.decreaseSize(sizeOption.text)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "number-item"
    }, [_vm._v(_vm._s(_vm.selectedSize[sizeOption.text]))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.increaseSize(sizeOption.text)
        }
      }
    }, [_vm._v("+")])])])
  }), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v(_vm._s(_vm.error.rewardConfigSize))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "text-remark"
  }, [_vm._v("หมายเหตุ: ขนาดของเสื้อเป็นขนาดมาตรฐาน Unisex")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_c('div', [_c('strong', [_vm._v("ระบุตำแหน่ง "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigChoice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุตำแหน่ง --")]), _vm._v(" "), _vm._l((_vm.LevelOptions), function(LevelOption) {
    return _c('option', {
      key: LevelOption.text,
      domProps: {
        "value": LevelOption.description
      }
    }, [_vm._v("\n                                      " + _vm._s(LevelOption.description) + "\n                                      ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigChoice) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุตำแหน่ง")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_c('div', [_c('strong', [_vm._v("ระบุหน่วยงานของท่าน "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigText),
      expression: "attributes.info.rewardConfigText"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigText", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุหน่วยงาน --")]), _vm._v(" "), _vm._l((_vm.FunctionOptions), function(FunctionOption) {
    return _c('option', {
      key: FunctionOption.text,
      domProps: {
        "value": FunctionOption.description
      }
    }, [_vm._v("\n                                      " + _vm._s(FunctionOption.description) + "\n                                      ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigText) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุหน่วยงานของท่าน")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid pa-0 pt-15 mt-15"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', [_c('strong', [_vm._v("ระบุสถานที่รับของที่ระลึก "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-remark"
  }, [_vm._v("พนักงานสาขาจัดส่งให้ที่สาขา โปรดระบุสาขาที่รับของท่านให้ถูกต้อง")])]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupPoint),
      expression: "attributes.info.pickupPoint"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "pickupPoint", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุสถานที่ --")]), _vm._v(" "), _vm._l((_vm.PlaceOptions), function(PlaceOption) {
    return _c('option', {
      key: PlaceOption.name,
      domProps: {
        "value": PlaceOption.name
      }
    }, [_vm._v("\n                                " + _vm._s(PlaceOption.name) + "\n                              ")])
  })], 2)]), _vm._v(" "), (_vm.error.pickupPoint) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุสาขาที่รับของที่ระลึก")]) : _vm._e(), _vm._v(" "), (_vm.isPlaceOptionType('select')) ? _c('div', [(_vm.selectedPlaceOption.params.optionTitle) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.optionTitle) + " "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupDetail),
      expression: "attributes.info.pickupDetail"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "pickupDetail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-- " + _vm._s(_vm.selectedPlaceOption.params.optionLabel) + " --")]), _vm._v(" "), _vm._l((_vm.selectedPlaceOption.params.optionType.items), function(item) {
    return _c('option', {
      key: item.name,
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                                    " + _vm._s(item.name) + "\n                                  ")])
  })], 2)]), _vm._v(" "), (_vm.error.pickupDetail) ? _c('div', {
    staticClass: "alert alert--error"
  }, [(_vm.selectedPlaceOption.params.required) ? _c('span', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.required))]) : _c('span', [_vm._v("กรุณากรอกข้อมูล")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {}, [(_vm.isPlaceOptionType('text')) ? _c('div', {}, [(_vm.selectedPlaceOption.params.optionLabel) ? _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "info_name2_text"
    }
  }, [_c('strong', [_vm._v("\n                                  " + _vm._s(_vm.selectedPlaceOption.params.optionLabel) + " "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-remark"
  }, [_vm._v(_vm._s(_vm.selectedPlaceOption.params.optionNote))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupDetail),
      expression: "attributes.info.pickupDetail"
    }],
    staticClass: "form__text",
    attrs: {
      "id": "info_name2_text",
      "type": "text"
    },
    domProps: {
      "value": (_vm.attributes.info.pickupDetail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributes.info, "pickupDetail", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error.pickupDetail) ? _c('div', {
    staticClass: "alert alert--error"
  }, [(_vm.selectedPlaceOption.params.required) ? _c('span', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.required))]) : _c('span', [_vm._v("กรุณากรอกข้อมูล")])]) : _vm._e()]) : _vm._e()])])])])])])], 1)]), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert--warning"
  }, [_vm._v("โปรดตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่มสั่งของที่ระลึก")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("กดเพื่อบริจาค/ชำระเงิน")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-2 col-md-8"
  }, [_c('div', {
    staticClass: "text-center mb-10"
  }, [_c('img', {
    staticClass: "logo pd-15 ma-auto d-block",
    attrs: {
      "src": "/static/img/uob/logo-tcfe-uob@2x.png",
      "srcset": "/static/img/uob/logo-tcfe-uob@2x.png",
      "alt": "TCFE x UOB"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v("2024 UOB Heartbeat Run"), _c('br'), _vm._v("(Set A)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "small"
  }, [_vm._v("ทางผู้จัดงานจะแจ้งให้ท่านทราบวันที่สามารถรับของที่ระลึกได้ในเดือนกรกฎาคม 2567"), _c('br'), _c('span', {
    staticClass: "text-remark"
  }, [_vm._v("(เนื่องจากการผลิตใช้เวลา 1 เดือน)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7451f8b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/uob-2024-set-a.vue
// module id = 1184
// module chunks = 0